import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, Paper, Tooltip, TextField, Autocomplete, Box, Stack } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, LabelList, ResponsiveContainer } from 'recharts';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetOutletComboMutation, useGetLaunchingComboMutation, useGetSaleReportsMutation } from '../../services/reports';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateRange from '../tools/daterange';
import ImportExcel from './importExcel';
import CustomTable from '../tools/customTable';
const API_URI = process.env.REACT_APP_API_URI;

export default function SellingRate() {
  const [getOutlets, outletsResult] = useGetOutletComboMutation();
  const [getLaunchingCombo, launchingResult] = useGetLaunchingComboMutation();
  const [getSaleReports, saleReportsResult] = useGetSaleReportsMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setColumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [viewDetail, setViewDetail] = useState(0);
  const [outlets, setOutlets] = useState([]);
  const [lstLaunching, setLstLaunching] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("All");
  const [selectedStore, setSelectedStore] = useState({});
  const [selectedLaunching, setSelectedLaunching] = useState("All");
  const [userId, setUserId] = useState(0);
  const [openImport, setOpenImport] = useState(false);
  const gridRef = useRef();
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
      { make: 'Total', model: '', TOTAL: 0 }
  ]);
  
  ModuleRegistry.registerModules([ AllCommunityModule ]);

  useEffect(() => {
    handleGridHeight();
    getLaunchingCombo();
    getOutlets();

    const uId = JSON.parse(window.localStorage.getItem("user"))?.id;
    setUserId(uId);

    window.addEventListener("resize", handleGridHeight);
    return () => {
      window.removeEventListener("resize", handleGridHeight);
    };
  }, []);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?.clientHeight || 0) - 66);
  }

  // useEffect(() => {
  //   if(saleReportsResult.data)
  //   {
  //     const dt = JSON.parse(saleReportsResult.data);
  //     setDataLoaded(dt);
  //     if(dt.length > 0)
  //       getCoumns(dt[0]);
  //     updatePinnedBottomRow(null, dt);
  //   }
  // }, [saleReportsResult]);

  useEffect(() => {
    if(outletsResult.data)
    {
      const dt = JSON.parse(outletsResult.data);
      let st = [];
      dt.map(m=>{
        st.push({value: m.ID, label: m.LOCATIONNAME, ...m})
      })
      setOutlets(st);
    }
  }, [outletsResult]);

  useEffect(() => {
    if(launchingResult.data)
    {
      const dt = JSON.parse(launchingResult.data);
      let st = [];
      dt.map(m=>{
        st.push({value: m.Launching, label: m.Launching, ...m})
      })
      setLstLaunching(st);
    }
  }, [launchingResult]);

  const getDataView=async()=>{
    if(!range) return;
    try{
      const result = await getSaleReports({"ReportID": "SellingRate", "FromDate": moment(range.from).format('DD-MM-YYYY')
        , "ToDate": moment(range.to).format('DD-MM-YYYY'), "Group": (selectedGroup=="All"?"":selectedGroup)
        , "Code": selectedStore.value||0, "Launching": selectedLaunching}).unwrap();
      const dt = JSON.parse(result);
      setDataLoaded(dt);
      if(dt.length > 0)
        getCoumns(dt[0]);
      updatePinnedBottomRow(null, dt);

      handleGridHeight();
      gridRef.current.setFilterModel(null);
    } catch (err) {
      setSnackContent("Lỗi kết nối!");
      console.error(err);
    }
  }

  const onChangeGroup=(record)=>{
    setSelectedGroup(record.value);
  }

  const onChangeStore=(record)=>{
    setSelectedStore(record);
  }

  const onChangeLaunching=(record)=>{
    setSelectedLaunching(record.value);
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        filter: true,
        headerName: key.replace('__', '/ '),
        width: key=="Description"?280:key=="LaunchMonth"?150:(key.length>12?200:120),
        cellStyle: () => ((key=="Order" || key=="D2C" || key=="Ecom" || key=="B2B" || key=="SOH_D2C" || key=="SOH_DC" || key=="SOH_VN")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="TotalNet" ? "bold" : ""
        }:null),
        // valueFormatter: params => params.data[key] && (
        //   (key=="FirstSellingDate")?moment(params.data[key]).format("YYYY-MM-DD")
        //   :(key=="Order" || key=="D2C" || key=="ECOM" || key=="B2B")?new Intl.NumberFormat('en-US').format(params.data[key]):params.data[key]
        // ),
        hide: (key=="SalesN"||key=="SalesC"||key=="SalesS"||key=="SalesSW"||key=="StockN"||key=="StockC"||key=="StockS"||key=="StockSW"
          ||((selectedStore.value||0) != 0 && (key=="Input__Order"||key=="HaveSellout__HaveStock"||key=="D2C__SOH"))?true:false),
        cellRenderer: (props) => CustomCell(props, key)
      }
    });
    setColumns(cols);
  }

  const CustomCell = (props, key) => {
    if(key=="FirstSellingDate")
      return props.value?moment(props.value).format("DD/MM/YYYY"):'';
    else if(key=="Order" || key=="D2C" || key=="Ecom" || key=="B2B" || key=="SOH_D2C" || key=="SOH_DC" || key=="SOH_VN")
      return new Intl.NumberFormat('en-US').format(props.value);
    else if(key=="Description"){
      const data = [
        { name: 'South', sales: props.data.SalesS, stock: props.data.StockS },
        { name: 'North', sales: props.data.SalesN, stock: props.data.StockN },
        { name: 'Central', sales: props.data.SalesC, stock: props.data.StockC },
        { name: 'Southwest', sales: props.data.SalesSW, stock: props.data.StockSW },
      ];
      return <Tooltip placement="right" 
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'white', // Set the background color
                      color: 'white',     // Optional: set the text color for contrast
                      '& .MuiTooltip-arrow': { // Optional: style the arrow
                        color: 'white',
                      },
                      border: '2px solid lightblue'
                    },
                  },
                }}
              title={<div style={{ width: '300px', height: 300, textAlign: 'center', fontFamily: 'sans-serif' }}>
                      <h3 style={{ color: '#3b3939', marginBottom: 0 }}>{props.data.Description} - {props.data.Color}</h3>
                      <p style={{ color: '#555050', marginTop: 5 }}>
                        ({props.data.SalesN+props.data.SalesC+props.data.SalesS+props.data.SalesSW} / {props.data.StockN+props.data.StockC+props.data.StockS+props.data.StockSW})</p>
                      
                      <ResponsiveContainer width="100%" height="85%">
                        <BarChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 5 }}>
                          {/* horizontal={true} vertical={false} gives you the subtle lines from your image */}
                          <CartesianGrid vertical={false} stroke="#eee" />
                          <XAxis dataKey="name" axisLine={false} tickLine={false} stroke="#090909" />
                          <YAxis hide />

                          <Bar dataKey="sales" stackId="a" fill="#02a2e3">
                            <LabelList dataKey="sales" position="center" fill="#fff" />
                          </Bar>

                          <Bar dataKey="stock" stackId="a" fill="#e0dbcf">
                            <LabelList dataKey="stock" position="center" fill="#333" 
                              formatter={(value) => (value > 0 ? value : '')} 
                            />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>}
            ><Button>{props.value}</Button></Tooltip>;
    }
    else if(key=="SellThruD2C__All"){
      let startDate = null;
      let endDate = range.to > moment() ? moment() : moment(range.to);
      if(props.data.Launching && props.data.LaunchMonth)
        startDate = moment(`20${props.data.Launching.substring(2, 4)} ${props.data.LaunchMonth} 01`);
      if(startDate < range.from)
        startDate = range.from;
      const days = endDate.diff(startDate, 'days');
      const percent = props.value.split('/')[0].replace('%', '').trim();
      const color = (days<=30?15:days<=60?30:days<=90?40:days<=120?50:days<=150?58:65) <= percent ? 'green': 'red';
      return <span style={{color: color}}>{props.value}</span>;
    }
    else return props.value;
  };

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const updatePinnedBottomRow = (api, data) => {
    let D2C = 0, Ecom = 0, B2B = 0, SOH_D2C = 0, SOH_DC = 0, SOH_VN = 0, inputQty = 0, orderQty = 0;
    if(data)
      data.map(m=>{
        const order_input = m.Input__Order.split('/');
        inputQty += parseInt(order_input[0].trim()||0);
        orderQty += parseInt(order_input[1].trim()||0);
        const d2c_soh = m.D2C__SOH.split('/');
        D2C += parseInt(d2c_soh[0].trim()||0);
        SOH_D2C += parseInt(d2c_soh[1].trim()||0);
        Ecom += m.Ecom;
        B2B += m.B2B;
        SOH_DC += m.SOH_DC;
        SOH_VN += m.SOH_VN;
      })
    else
      api.forEachNodeAfterFilter((node) => {
        const order_input = node.data.Input__Order.split('/');
        inputQty += parseInt(order_input[0].trim()||0);
        orderQty += parseInt(order_input[1].trim()||0);
        const d2c_soh = node.data.D2C__SOH.split('/');
        D2C += parseInt(d2c_soh[0].trim()||0);
        SOH_D2C += parseInt(d2c_soh[1].trim()||0);
        Ecom += node.data.Ecom;
        B2B += node.data.B2B;
        SOH_DC += node.data.SOH_DC;
        SOH_VN += node.data.SOH_VN;
      });
    setPinnedBottomRowData([{ make: 'Total', model: '', Ecom: Ecom, B2B: B2B, SOH_DC: SOH_DC, SOH_VN: SOH_VN
      , D2C__SOH: `${D2C}/${SOH_D2C}`
      , Input__Order: `${inputQty}/${orderQty}`
      , SellThruD2C__All: `${((SOH_D2C?D2C/(SOH_D2C+D2C):0)*100).toFixed(1)}% / ${((SOH_VN?(D2C+Ecom+B2B)/(SOH_VN + D2C+Ecom+B2B):0)*100).toFixed(1)}%`
     }]);
  };

  const onFilterChanged = useCallback(() => {
    if (gridRef.current) {
        updatePinnedBottomRow(gridRef.current);
    }
  }, []);

  const exportExcel = async (detail) => {
    // const params = JSON.stringify({ReportID: 'ExportSellingRate',fromdate: moment(range.from).format('YYYY-MM-DD'), todate: moment(range.to).format('YYYY-MM-DD')})
    // const encodedData = btoa(unescape(encodeURIComponent(params)));
    // window.open(`${API_URI}/reports/exporttoexcel?strparams=${encodedData}`, '_blank', 'noopener,noreferrer');
    let dt = [];
    if(detail){
      const result = await getSaleReports({"ReportID": "ExportSellingRate", "FromDate": moment(range.from).format('DD-MM-YYYY')
        , "ToDate": moment(range.to).format('DD-MM-YYYY'), "Group": (selectedGroup=="All"?"":selectedGroup)
        , "Code": selectedStore.value||0, "Launching": selectedLaunching}).unwrap();
      dt = JSON.parse(result);
    }
    else dt = dataLoaded;

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(dt, { origin: 3 });
    ws['!cols'] = [
      { wch: 20 }, // Column A
      { wch: 30 } // Column B
    ];
    XLSX.utils.sheet_add_aoa(ws, [
      [{v: selectedStore.label||'All' + ' | SELLING RATE', t: "s", s: {font: { bold: true }}}],
      ['From', moment(range.from).format('DD-MMM-YY'), '', '', '', 'Number od day'],
      ['To', moment(range.to).format('DD-MMM-YY'), '', '', '', moment(range.to).diff(moment(range.from), 'days')]
    ], { origin: 'A1' });
    for(var i=0; i<Object.keys(dt[0]).length; i++){
      var cell_address = { c: i, r: 3 };//column, row
      var cell_ref = XLSX.utils.encode_cell(cell_address);
      ws[cell_ref].s = {// font: { name: "Arial", sz: 14, bold: true, color: { rgb: "000000" } },// alignment: { horizontal: "left", vertical: "center" }
        fill: { fgColor: { rgb: "EFEFEF" } },
      };
    }
    
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "SellingRate.xlsx");
  }

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  return (
    <div style={{padding: '0 10px'}}>
      { (saleReportsResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '10px'}}>
        <Box id='divHeader' sx={{ width: '100%' }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{
              overflowX: 'auto', pt: 1, mb: 0.5,
              pb: 0.5, // Space for the scrollbar so it doesn't touch the buttons
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              // Ensure items don't shrink and stay on one line
              flexWrap: 'nowrap',
            }}
          >
            <Box sx={{ flexShrink: 0 }}>
              <DateRange range={range} setRange={setRange} />
            </Box>
            <Autocomplete disablePortal size="small"
              options={[{value: 'All', label: 'All'}, {value: 'Brief', label: 'Brief'}
                , {value: 'Corsetry', label: 'Corsetry'}, {value: 'Underwear', label: 'Underwear'}]}
              sx={{ flexShrink: 0, width: 150 }}
              onChange={(e, item)=>onChangeGroup(item)}
              renderInput={(params) => <TextField {...params} label="Group" />}
              disableClearable
            />
            <Autocomplete disablePortal size="small"
              options={outlets}
              sx={{ flexShrink: 0, width: 350 }}
              onChange={(e, item)=>onChangeStore(item)}
              renderInput={(params) => <TextField {...params} label="Store" />}
              loading={outletsResult.isLoading}
              disableClearable
            />
            <Autocomplete disablePortal size="small"
              options={lstLaunching}
              sx={{ flexShrink: 0, width: 170 }}
              onChange={(e, item)=>onChangeLaunching(item)}
              renderInput={(params) => <TextField {...params} label="Launching" />}
              loading={lstLaunching.isLoading}
              disableClearable
            />
            <Button variant="contained" onClick={getDataView}
              sx={{ flexShrink: 0 }}>View</Button>
            <Button variant="contained" onClick={()=>exportExcel(0)}
              sx={{ flexShrink: 0 }}>Export</Button>
            <Button variant="contained" onClick={()=>exportExcel(1)}
              sx={{ flexShrink: 0 }}>Export Detail</Button>
            {
              // (userId == 89 || userId == 26) && <Button variant="contained" color="warning" onClick={(e)=>setOpenImport('ProductStatus')}
              //                 sx={{ flexShrink: 0 }}>Import Status</Button>
            }
          </Stack>
        </Box>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact enableCellTextSelection={true} ensureDomOrder={true}
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
          />
        </Paper>
        {/* <CustomTable /> */}
      </div>

      <ImportExcel open={openImport} setOpen={setOpenImport} />

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}